
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/asana",
      function () {
        return require("private-next-pages/destinations/asana.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/asana"])
      });
    }
  